import { vhcCheckBrakeItemNames, vhcCheckItemNames, vhcCheckWheelTyreItemNames } from '../../vhc/model/constants';
import {
  VHCRecordCheckBrakeItemTypesVHCRecordLabourDto,
  VHCRecordCheckBrakeItemTypesVHCRecordPartDto,
  VHCRecordCheckItemTypesVHCRecordLabourDto,
  VHCRecordCheckItemTypesVHCRecordPartDto,
  VHCRecordCheckWheelTyreItemTypesVHCRecordLabourDto,
  VHCRecordCheckWheelTyreItemTypesVHCRecordPartDto,
  VHCRecordItemGroups
} from 'api/generated';

type RecordItemType =
  | VHCRecordCheckBrakeItemTypesVHCRecordLabourDto
  | VHCRecordCheckItemTypesVHCRecordLabourDto
  | VHCRecordCheckWheelTyreItemTypesVHCRecordLabourDto
  | VHCRecordCheckWheelTyreItemTypesVHCRecordPartDto
  | VHCRecordCheckBrakeItemTypesVHCRecordPartDto
  | VHCRecordCheckItemTypesVHCRecordPartDto;

const groupOrder = [
  {
    group: VHCRecordItemGroups.ExternalOrDriveIn,
    names: vhcCheckItemNames
  },
  {
    group: VHCRecordItemGroups.Internal,
    names: vhcCheckItemNames
  },
  {
    group: VHCRecordItemGroups.UnderBonnet,
    names: vhcCheckItemNames
  },
  {
    group: VHCRecordItemGroups.Underside,
    names: vhcCheckItemNames
  },
  {
    group: VHCRecordItemGroups.BrakesAndHubs,
    names: vhcCheckBrakeItemNames
  },
  {
    group: VHCRecordItemGroups.WheelsAndTyres,
    names: vhcCheckWheelTyreItemNames
  }
];

export const getRecordCheckItemType = <T extends RecordItemType>(item: T): string => {
  const vHCRecordItemGroup = (item as any).vHCRecordItemGroup;

  if (vHCRecordItemGroup !== undefined && item.checkItemType !== undefined) {
    const itemGroupNames = groupOrder[vHCRecordItemGroup];
    const itemCheckTypeName = itemGroupNames.names[item.checkItemType];
    return itemCheckTypeName;
  }
  return item.checkItemType !== undefined ? vhcCheckItemNames[item.checkItemType] : '';
};
